/* product-hampers.js - gallery hover, thumb clicks, accordions */
document.addEventListener('DOMContentLoaded', function () {
  // Gallery hover to second image
  var mainImg = document.querySelector('.ph-main-image');
  if (mainImg) {
    var defaultSrc = mainImg.getAttribute('data-default-src') || mainImg.getAttribute('src');
    var hoverSrc = mainImg.getAttribute('data-hover-src');

    if (hoverSrc) {
      mainImg.addEventListener('mouseenter', function () {
        mainImg.setAttribute('src', hoverSrc);
      });
      mainImg.addEventListener('mouseleave', function () {
        mainImg.setAttribute('src', defaultSrc);
      });
    }

    // thumbnail clicks
    var thumbs = document.querySelectorAll('.ph-thumb-btn');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-img-src');
        if (src) {
          mainImg.setAttribute('src', src);
          mainImg.setAttribute('data-default-src', src);
        }
      });
    });
  }

  // Accordions
  var accToggles = document.querySelectorAll('.ph-accordion-toggle');
  accToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      var isOpen = panel.style.display === 'block';
      // close all panels
      document.querySelectorAll('.ph-accordion-panel').forEach(function (p) { p.style.display = 'none'; });
      if (!isOpen) panel.style.display = 'block';
      // update aria-expanded
      document.querySelectorAll('.ph-accordion-toggle').forEach(function(t){ t.setAttribute('aria-expanded', 'false'); });
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      // smooth scroll to panel on mobile
      if (window.innerWidth < 600 && !isOpen) {
        setTimeout(function () { panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250);
      }
    });
  });

  // Touch safety: remove hover listeners on touch devices (no hover)
  if ('ontouchstart' in window) {
    var hoverImgs = document.querySelectorAll('[data-hover-src]');
    hoverImgs.forEach(function (img) {
      // nothing to do; hover events won't fire on touch
    });
  }
});
